import {createRouter, createWebHashHistory, RouteRecordRaw} from "vue-router";
// import Home from "@/views/Home.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home",
    component: () => import("@/views/Home.vue"),
  },
  {
    path: "/forceLogin",
    name: "ForceLogin",
    component: () => import("@/views/ForceLogin.vue"),
  },
  {
    path: "/cms",
    component: () => import("@/views/cms/Layout.vue"),
    children: [
      {
        path: "dashboard",
        component: () => import("@/views/cms/Dashboard.vue"),
      },
      {
        path: "contract",
        component: () => import("@/views/cms/Contract.vue"),
        children: [
          {
            path: "add",
            component: () => import("@/views/cms/contract/Form.vue"),
          },
          {
            path: "list",
            component: () => import("@/views/cms/contract/List.vue"),
          },
        ],
      },
      {
        path: "contents",
        component: () => import("@/views/cms/Contents.vue"),
      },
      {
        path: "stat",
        component: () => import("@/views/cms/Stat.vue"),
        children: [
          {
            path: "contentsComic",
            component: () => import("@/views/cms/stat/ContentsComic.vue"),
          },
          {
            path: "contentsEpisode/:platform/:id",
            component: () => import("@/views/cms/stat/ContentsEpisode.vue"),
          },
          {
            path: "monthlyContents/Kr",
            component: () => import("@/views/cms/stat/MonthlyContentsKr.vue"),
          },
          {
            path: "monthlyContents/ASP",
            component: () => import("@/views/cms/stat/MonthlyContentsASP.vue"),
          },
          {
            path: "monthlyContents/Tw",
            component: () => import("@/views/cms/stat/MonthlyContentsTw.vue"),
          },
          {
            path: "monthlyContents/En",
            component: () => import("@/views/cms/stat/MonthlyContentsEn.vue"),
          },
          {
            path: "monthlyContents/Ja",
            component: () => import("@/views/cms/stat/MonthlyContentsJa.vue"),
          },
          {
            path: "monthlyContents/Chat",
            component: () => import("@/views/cms/stat/MonthlyContentsChat.vue"),
          },
          {
            path: "monthlyContents/ChatTw",
            component: () => import("@/views/cms/stat/MonthlyContentsChatTw.vue"),
          },
          {
            path: "monthlyContents/ChatAsp",
            component: () => import("@/views/cms/stat/MonthlyContentsChatAsp.vue"),
          },
          {
            path: "monthlyContents/ChatJa",
            component: () => import("@/views/cms/stat/MonthlyContentsChatJa.vue"),
          },
          {
            path: "distributionSales",
            component: () => import("@/views/cms/stat/DistributionSales.vue"),
          },
        ],
      },
      {
        path: "receipt",
        component: () => import("@/views/cms/Receipt.vue"),
        children: [
          {
            path: "mg",
            component: () => import("@/views/cms/receipt/Mg.vue"),
          },
          {
            path: "rs",
            component: () => import("@/views/cms/receipt/Rs.vue"),
          },
        ],
      },
      {
        path: "board",
        component: () => import("@/views/cms/Board.vue"),
        children: [
          {
            path: "notice",
            component: () => import("@/views/cms/board/Notice.vue"),
          },
          {
            path: "qna",
            component: () => import("@/views/cms/board/Qna.vue"),
          },
        ],
      },
    ],
  },
  {
    path: "/404",
    component: () => import("@/views/Error404.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
    // component: () => import("@/views/Error404.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
